import React, { Component } from 'react';

class RoomOfferLoader extends Component {

	render() {
		return (
			<div className={`room-offer ${this.props.isLast ? 'room-offer--last' : ''}`} data-nav-loading-indicator="true">
				<div className="room-offer__gallery">
					<div className="room-offer__photo-container">
						<div className="room-offer__photo room-offer__photo--loader" />
					</div>
				</div>
				<div className="room-offer__text-container">
					{/* Nadpis */}
					<div className="room-offer-loader room-offer-loader--taller" style={{
						width: '50%',
						marginRight: '20px',
						marginBottom: '10px'
					}} />

					{/* Features */}
					<div className="room-offer-loader inline-block" style={{
						width: '20px',
						marginRight: '5px',
					}} />
					<div className="room-offer-loader inline-block" style={{
						width: '80px',
						marginRight: '10px',
					}} />
					<div className="room-offer-loader inline-block" style={{
						width: '20px',
						marginRight: '5px',
					}} />
					<div className="room-offer-loader inline-block" style={{
						width: '80px',
						marginRight: '10px',
					}} />
					<div className="room-offer-loader inline-block" style={{
						width: '20px',
						marginRight: '5px',
					}} />
					<div className="room-offer-loader inline-block" style={{
						width: '80px',
						marginRight: '10px',
					}} />

					{/* Popisek */}
					<div className="room-offer-loader" style={{
						marginTop: '10px',
						marginBottom: '5px',
					}} />
					<div className="room-offer-loader" style={{
						marginBottom: '5px',
					}} />
					<div className="room-offer-loader" style={{
						width: '30%',
						marginBottom: '15px',
					}} />

					{/* Ceny a select */}
					<div className="room-offer-count">
						<div className="room-offer-count__price-container">
							<div className="room-offer-loader room-offer-loader--taller " style={{
								width: '120px',
								marginBottom: '5px'
							}} />
							<div className="room-offer-loader" style={{
								width: '160px',
							}} />
						</div>
						<div className="room-offer-loader" style={{
							width: '160px',
							height: '56px',
						}} />
					</div>


				</div>
			</div>
		);
	}
}

export default RoomOfferLoader;



// WEBPACK FOOTER //
// ./src/components/Rooms/RoomOfferLoader.jsx